const riot = require('riot');
riot.tag2('customer', '<div class="card is-collapse"> <header class="card-header {has-background-light:expanded}" onclick="{toggleExpand}"> <div class="card-header-title" style="display:block;font-weight:normal;padding:0.25rem 0.5rem"> <strong>{name}</strong> <a onclick="{setMarketFilter(market)}"><small>{market || \'??\'}</small></a> - <small>{_id}</small> <br> <small>{sites.join(\'\\n\')}</small> </div> <div class="card-header-icon" aria-label="more options" style="padding:1rem 0.5rem"> <span if="{hasTargeting}" class="tag is-small" title="uses targeted advertising">TG</span> <a href="#" onclick="{toggleExpanded}" aria-label="more options"> <span class="icon"> <i class="fas fa-angle-down" aria-hidden="true"></i> </span> </a> </div> </header> <div if="{expanded}" class="card-content has-background-white-bis" style="margin-bottom:1rem"> <form> <div class="columns"> <div class="column"> <div class="field is-grouped"> <div class="control"> <label for="id" class="label">ID</label> <input class="input is-static" readonly type="text" riot-value="{_id}" id="id"> </div> <div class="control"> <label for="hasTargeting" class="label">Targeted Ads</label> <input type="checkbox" id="hasTargeting" ref="hasTargeting" class="switch" checked="{hasTargeting}" onclick="{toggleTargeting}"> <label for="hasTargeting">Uses targeted advertising</label> </div> </div> <div class="field control"> <label for="name" class="label">Name</label> <input class="input" type="text" riot-value="{name}" id="name" ref="name"> </div> <div class="field control"> <label for="owner" class="label">Owner</label> <input class="input" type="text" riot-value="{owner}" id="owner" ref="owner"> </div> <div class="field control"> <label for="sites" class="label">Sites</label> <textarea id="sites" rows="{sites.length + 2}" ref="sites" class="textarea">{sites.join(\'\\n\')}</textarea> </div> <div class="field control"> <label for="code" class="label">Sites in ContentExchange</label> <table class="table"> <thead> <tr> <td>Site</td> <td></td> </thead> <tbody> <tr each="{target_sites}"> <td><small>{name}</small></td> <td><a href="" title="unlink site" onclick="{unlinkSite}"><span class="icon is-small"><i class="fas fa-times"></i></span></a></td> </tr> </tbody> <tfoot> <tr> <td> <div class="select is-small"> <select name="new_site" ref="new_site"> <option value="">Select target site</option> <option each="{target_options}" riot-value="{_id}">{name}</option> </select> </div> </td> <td><a href="" title="link site" onclick="{linkSite}"><span class="icon is-small"><i class="fas fa-plus"></i></span></a></td> </tr> </tfoot> </table> </div> </div> <div class="column"> <div class="field is-grouped"> <div class="control"> <label for="code" class="label">Market</label> <div class="select is-small"> <select name="new_market" ref="new_market" onchange="{setMarket}"> <option each="{m in market_options}" selected="{market==m._id}" riot-value="{m._id}">{m.name}</option> </select> </div> </div> <div class="control"> <label for="noIframes" class="label">No iframes</label> <input type="checkbox" id="noIframes" ref="noIframes" class="switch" checked="{noIframes}" onclick="{toggleIframes}"> <label for="noIframes">Do not load customer code in iframes</label> </div> </div> <div class="field control"> <label for="code" class="label">Embed code</label> <textarea id="code" rows="5" ref="code" class="textarea">&lt;script async src="https://analytics.contentexchange.me/bex/load/{_id}">&lt;/script></textarea> </div> <div class="field control"> <label for="exclude" class="label">Do not send pageview</label> <textarea id="exclude_ips" rows="5" ref="exclude" class="textarea">{exclude_ips.join(\'\\n\')}</textarea> <small>Enter list of IPs, one IP per line, leave empty to disable</small> </div> </div> </div> <div class="field is-grouped is-grouped-centered"> <div class="control"> <button class="button is-info" onclick="{saveCustomer}">Save changes</button> </div><div class="control is-hidden"> <button class="button is-light" onclick="{removeCustomer}">Remove customer</button> </div> </div> </form> </div> </div>', '', '', function(opts) {
  const conf = api.get('config');

  var self = this,
      sites = [],
      sitemap = {}

  self.exclude_ips = self.exclude_ips || []
  self.setMarketFilter = self.parent.setMarketFilter

  self.market = self.market || 'sl'
  self.market_options = self.parent.market_options

  this.setMarket = function(e) {
    e.preventDefault()
    self.market = self.refs.new_market.value
  }.bind(this)

  self.users = {}
  self.sites = self.sites || []

  this.toggleExpand = function(e) {
    e.preventDefault()
    e.stopPropagation()
    self.expanded = !self.expanded
  }.bind(this)

  self.on('mount',function() {
    self.target_sites = self.target_sites || []
    self.sites = self.sites || []
    api.service('sites').find({query:{$limit:500}})
    .then(res => {
      sites = res.data
      sites.forEach(s => sitemap[s._id] = {_id:s._id, name:s.name, url:s.url.replace(/https?:\/\//,'').replace(/\/?$/,'')})
      self.target_options = sites.filter(s => !s.customer_id)
      self.update()
    })
  })

  this.linkSite = function(e) {
    e.preventDefault()
    const id = self.refs.new_site.value
console.log('linkSite',id)
    if (!id) return api.emit('toast', { type: 'danger', title: 'No site selected'})
    self.target_sites.push(sitemap[id])
    self.target_options = self.target_options.filter(s => s._id!=id)
    api.service('sites').patch(id,{
      customer_id:self._id,
      customer_name:self.name,
    })
  }.bind(this)

  this.toggleTargeting = function(e) {

    self.hasTargeting = self.refs.hasTargeting.checked==true
    console.log('set targeting',self.refs.hasTargeting.checked,self.refs.hasTargeting.value)
  }.bind(this)

  this.toggleIframes = function(e) {

    self.noIframes = self.refs.noIframes.checked==true
    console.log('set iframes',self.refs.noIframes.checked,self.refs.noIframes.value)
  }.bind(this)

  this.unlinkSite = function(e) {
    e.preventDefault()
    const id = e.item._id
    self.target_sites = self.target_sites.filter(s => s._id!=id)
    self.target_options.push(sitemap[id])
    api.service('sites').patch(id,{
      customer_id:null,
      customer_name:"",
    })
  }.bind(this)

  this.saveCustomer = function(e) {
    e.preventDefault()
console.log('REFS',self.refs.sites.value)
    const sites = self.refs.sites.value || "",
          ips = self.refs.exclude.value || "",
          c = {
            name:self.refs.name.value,
            owner:self.refs.owner.value,
            sites:sites.split(/\n/g),
            target_sites: self.target_sites,
            hasTargeting: self.hasTargeting,
            noIframes: self.noIframes,
            exclude_ips:ips.split(/\n/g),
            market: self.market
          }
    api.service('customers')
    .patch(e.item._id,c)
    .then(r => {
      const id = self.parent.customers.findIndex(d => d._id==e.item._id)
      c._id = e.item._id
      self.parent.customers[id] = c
      self.parent.update()

			fetch(conf.tracker + '/bex/reset-customer/' + c._id)
				.then(() => {
					api.emit('toast', { type: 'info', title: 'Customer saved' });
					self.update();
				})
				.catch(err => {
					api.emit('toast', { type: 'danger', title: 'Error resetting customer', content: conf.tracker + '/bex/reset-customer/' + c._id });
					self.update();
				});

    })
    .catch(e => {
      console.log('error patching customer',e)
      self.error = e.message
      self.update()
    })
    console.log('saving',e)
  }.bind(this)
});

